import Vue from 'vue'
import Router from 'vue-router'
import UpenbeEdit from '@/router/page/upenbeEdit'
import axios from 'axios'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'main',
    component: () => import('@/router/page/main.vue')
  }, {
    path: '/admin',
    component: () => import('@/router/admin/main'),
    redirect: (to) => {
      if (to.path === '/admin') {
        return '/admin/login'
      }
    },
    children: [{
      path: 'login',
      name: 'admin-login',
      component: () => import('@/router/admin/login')
    }, {
      path: 'auth/:token',
      name: 'admin-auth',
      redirect: (to) => {
        sessionStorage.setItem('token', to.params.token)
        return '/admin/contract/apply'
      }
    }, {
      path: 'abanner',
      name: 'admin-banner',
      component: () => import('@/router/admin/abanner/abanner.vue')
    }, {
      path: 'user',
      name: 'admin-user',
      component: () => import('@/router/admin/user/user')
    }, {
      path: 'userinfo/:userid',
      name: 'admin-userinfo',
      component: () => import('@/router/admin/user/userinfo')
    }, {
      path: 'contract',
      name: 'admin-contract',
      component: () => import('@/router/admin/contract/contract'),
      redirect: (to) => {
        if (to.path === '/admin/contract') {
          return '/admin/contract/apply'
        }
      },
      children: [{
        path: 'apply',
        name: 'admin-contract-apply',
        component: () => import('@/router/admin/contract/apply.vue')
      }, {
        path: 'complete',
        name: 'admin-contract-complete',
        component: () => import('@/router/admin/contract/complete.vue')
      }, {
        path: 'end',
        name: 'admin-contract-end',
        component: () => import('@/router/admin/contract/end.vue')
      }, {
        path: 'applycancel',
        name: 'admin-contract-applycancel',
        component: () => import('@/router/admin/contract/applycancel.vue')
      }, {
        path: 'contractcancel',
        name: 'admin-contract-contractcancel',
        component: () => import('@/router/admin/contract/contractcancel.vue')
      }]
    }, {
      path: 'publishing',
      name: 'admin-publishing',
      component: () => import('@/router/admin/publishing/publishing'),
      redirect: (to) => {
        if (to.path === '/admin/publishing') {
          return '/admin/publishing/apply'
        }
      },
      children: [{
        path: 'apply',
        name: 'admin-publishing-apply',
        component: () => import('@/router/admin/publishing/apply.vue')
      }, {
        path: 'sale',
        name: 'admin-publishing-sale',
        component: () => import('@/router/admin/publishing/sale.vue')
      }, {
        path: 'edit',
        name: 'admin-publishing-edit',
        component: () => import('@/router/admin/publishing/edit.vue')
      }, {
        path: 'end',
        name: 'admin-publishing-end',
        component: () => import('@/router/admin/publishing/end.vue')
      }, {
        path: 'applycancel',
        name: 'admin-publishing-applycancel',
        component: () => import('@/router/admin/publishing/applycancel.vue')
      }]
    }, {
      path: 'calculate',
      name: 'admin-calculate',
      component: () => import('@/router/admin/calculate/calculate.vue'),
      redirect: (to) => {
        if (to.path === '/admin/calculate') {
          return '/admin/calculate/create'
        }
      },
      children: [{
        path: 'create',
        name: 'admin-calculate-create',
        component: () => import('@/router/admin/calculate/create.vue')
      }, {
        path: 'apply',
        name: 'admin-calculate-apply',
        component: () => import('@/router/admin/calculate/apply.vue')
      }, {
        path: 'payments',
        name: 'admin-calculate-payments',
        component: () => import('@/router/admin/calculate/payments.vue')
      }, {
        path: 'complete',
        name: 'admin-calculate-complete',
        component: () => import('@/router/admin/calculate/complete.vue')
      }, {
        path: 'tax',
        name: 'admin-calculate-tax',
        component: () => import('@/router/admin/calculate/tax.vue')
      }]
    }, {
      path: 'cs',
      name: 'admin-cs',
      component: () => import('@/router/admin/cs/cs.vue'),
      redirect: (to) => {
        if (to.path === '/admin/cs') {
          return '/admin/cs/report'
        }
      },
      children: [{
        path: 'report',
        name: 'admin-cs-report',
        component: () => import('@/router/admin/cs/report.vue')
      }, {
        path: 'visible',
        name: 'admin-cs-visible',
        component: () => import('@/router/admin/cs/visible.vue')
      }, {
        path: 'edit',
        name: 'admin-cs-edit',
        component: () => import('@/router/admin/cs/edit.vue')
      }, {
        path: 'end',
        name: 'admin-cs-end',
        component: () => import('@/router/admin/cs/end.vue')
      }]
    }, {
      path: 'withdrawal',
      name: 'admin-withdrawal',
      component: () => import('@/router/admin/withdrawal/withdrawal.vue'),
      redirect: (to) => {
        if (to.path === '/admin/withdrawal') {
          return '/admin/withdrawal/fees'
        }
      },
      children: [{
        path: 'fees',
        name: 'admin-withdrawal-fees',
        component: () => import('@/router/admin/withdrawal/fees.vue')
      }, {
        path: 'apply',
        name: 'admin-withdrawal-apply',
        component: () => import('@/router/admin/withdrawal/apply.vue')
      }, {
        path: 'tax',
        name: 'admin-withdrawal-tax',
        component: () => import('@/router/admin/withdrawal/tax.vue')
      }, {
        path: 'complete',
        name: 'admin-withdrawal-complete',
        component: () => import('@/router/admin/withdrawal/complete.vue')
      }, {
        path: 'end',
        name: 'admin-withdrawal-end',
        component: () => import('@/router/admin/withdrawal/end.vue')
      }, {
        path: 'applycancel',
        name: 'admin-withdrawal-applycancel',
        component: () => import('@/router/admin/withdrawal/applycancel.vue')
      }]
    }, {
      path: 'settings',
      name: 'admin-settings',
      component: () => import('@/router/admin/settings/settings.vue'),
      redirect: (to) => {
        if (to.path === '/admin/settings') {
          return '/admin/settings/notice'
        }
      },
      children: [{
        path: 'notice',
        name: 'admin-settings-notice',
        component: () => import('@/router/admin/settings/notice.vue')
      }, {
        path: 'inspection',
        name: 'admin-settings-inspection',
        component: () => import('@/router/admin/settings/inspection.vue')
      }, {
        path: 'icon',
        name: 'admin-settings-icon',
        component: () => import('@/router/admin/settings/icon.vue')
      }, {
        path: 'footer',
        name: 'admin-settings-footer',
        component: () => import('@/router/admin/settings/footer.vue')
      }]
    }]
  }, {
    path: '/auth',
    component: {name: 'Auth', template: '<router-view></router-view>'},
    children: [{
      path: 'login',
      name: 'login',
      component: () => import('@/router/page/login/login')
    }, {
      path: 'join',
      name: 'join',
      component: () => import('@/router/page/login/join')
    }, {
      path: 'accountSearch',
      name: 'accountSearch',
      component: () => import('@/router/page/login/accountSearch')
    }, {
      path: 'insertAuth',
      name: 'insertAuth',
      props: true,
      beforeEnter: (to, from, next) => {
        sessionStorage.setItem('insertAuth', JSON.stringify(to.query))
        if (sessionStorage.getItem('token')) {
          next('/user/myinfo/account')
        } else {
          next('/auth/join')
        }
      }
    }, {
      path: 'loginAuth',
      name: 'loginAuth',
      props: true,
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('token')) {
          sessionStorage.setItem('isNotAuth', true)
          next('/user/myinfo/account')
        } else {
          sessionStorage.setItem('token', to.query.token)
          var q = JSON.stringify(to.query)
          console.log('link check', q.link, to.query.link.name, q.link.name)
          if (q.link && to.query.link.name) {
            next({name: q.link.name, params: q.link})
          } else {
            next({name: 'main', params: {login: true}})
          }
        }
      }
    }, {
      path: 'loginDormancy',
      name: 'loginDormancy',
      props: true,
      beforeEnter: (to, from, next) => {
        next({name: 'Dormancy', params: {email: to.query.email}})
      }
    }, {
      path: 'dormancy',
      name: 'Dormancy',
      component: () => import('@/router/page/login/dormancy')
    }]
  }, {
    path: '/user',
    component: {name: 'User', template: '<router-view></router-view>'},
    children: [{
      path: 'myinfo',
      name: 'myinfo',
      component: () => import('@/router/page/myinfo/myinfo'),
      children: [{
        path: 'profile',
        name: 'profile',
        component: () => import('@/router/page/myinfo/profileinfo')
      }, {
        path: 'account',
        name: 'account',
        component: () => import('@/router/page/myinfo/account')
      }, {
        path: 'password',
        name: 'password',
        component: () => import('@/router/page/myinfo/password')
      }, {
        path: 'proof',
        name: 'proof',
        component: () => import('@/router/page/myinfo/proof')
      }]
    }, {
      path: 'alarms',
      component: () => import('@/router/page/alarms/alarms'),
      children: [{
        path: 'alarm',
        name: 'alarm',
        component: () => import('@/router/page/alarms/alarmView')
      }, {
        path: 'notice',
        name: 'notice',
        component: () => import('@/router/page/alarms/notice')
      }]
    }, {
      path: 'point',
      name: 'point',
      component: () => import('@/router/page/point/point'),
      children: [{
        path: 'total',
        name: 'point-total',
        component: () => import('@/router/page/point/total')
      }, {
        path: 'buy',
        name: 'point-buy',
        component: () => import('@/router/page/point/buy')
      }, {
        path: 'withdrawal',
        name: 'point-withdrawal',
        component: () => import('@/router/page/point/withdrawal')
      }]
    }, {
      path: 'withdrawal/info/:type',
      name: 'withdrawal-info',
      component: () => import('@/router/page/point/withdrawal/info')
    }, {
      path: 'withdrawal/create/:type',
      name: 'withdrawal-create',
      component: () => import('@/router/page/point/withdrawal/create')
    }, {
      path: 'publishing',
      name: 'publishing',
      component: () => import('@/router/page/publishing/publishing'),
      children: [{
        path: 'contract',
        name: 'publishing-contract',
        component: () => import('@/router/page/publishing/contract')
      }, {
        path: 'book',
        name: 'publishing-book',
        component: () => import('@/router/page/publishing/book')
      }, {
        path: 'calculate',
        name: 'publishing-calculate',
        component: () => import('@/router/page/publishing/calculate')
      }]
    }, {
      path: 'company',
      name: 'user-terms-company',
      component: () => import('@/router/page/terms/company')
    }, {
      path: 'copyright',
      name: 'user-terms-copyright',
      component: () => import('@/router/page/terms/copyright')
    }, {
      path: 'adultcontent',
      name: 'user-terms-adultcontent',
      component: () => import('@/router/page/terms/adultcontent')
    }, {
      path: 'service',
      name: 'user-terms-service',
      component: () => import('@/router/page/terms/service')
    }, {
      path: 'paidservie',
      name: 'user-terms-paidservie',
      component: () => import('@/router/page/terms/paidservie')
    }, {
      path: 'personal',
      name: 'user-terms-personal',
      component: () => import('@/router/page/terms/personal')
    }, {
      path: 'managing',
      name: 'user-terms-managing',
      component: () => import('@/router/page/terms/managing')
    }, {
      path: 'refund',
      name: 'user-terms-refund',
      component: () => import('@/router/page/terms/refund')
    }]
  }, {
    path: '/publishinginfo/:intro',
    name: 'publishing-bookinfo',
    component: () => import('@/router/page/publishing/publishinginfo')
  }, {
    path: '/library',
    component: () => import('@/router/page/library/library'),
    children: [{
      path: 'subscribe/:user',
      name: 'subscribe',
      component: () => import('@/router/page/library/subscribe')
    }, {
      path: 'booklist/:user',
      name: 'booklist',
      component: () => import('@/router/page/library/booklist/booklist')
    }, {
      path: 'worklist/:user',
      name: 'worklist',
      component: () => import('@/router/page/library/worklist')
    }, {
      path: 'workprofile/:user',
      name: 'workprofile',
      component: () => import('@/router/page/library/workprofile')
    }]
  }, {
    path: '/publishing',
    component: {template: '<router-view></router-view>'},
    // component: () => import('@/router/page/publishing/start'),
    children: [{
      path: 'agree/:book',
      name: 'publishing-agree',
      component: () => import('@/router/page/publishing/agree')
    }, {
      path: 'info/:book',
      name: 'publishing-info',
      component: () => import('@/router/page/publishing/info')
    }, {
      path: 'bookpublishing/:book',
      name: 'publishing-bookpublishing',
      component: () => import('@/router/page/publishing/bookpublishing')
    }, {
      path: 'bookintro/:book',
      name: 'publishing-intro',
      component: () => import('@/router/page/publishing/intro')
    }, {
      path: 'make/:book',
      name: 'publishing-make',
      component: () => import('@/router/page/publishing/make')
    }, {
      path: 'edit/:book/:epub',
      name: 'publishing-edit',
      component: () => import('@/router/page/publishing/make')
    }]
  }, {
    path: '/terms',
    component: {template: '<router-view></router-view>'},
    children: [{
      path: 'company',
      name: 'terms-company',
      component: () => import('@/router/page/terms/company')
    }, {
      path: 'copyright',
      name: 'terms-copyright',
      component: () => import('@/router/page/terms/copyright')
    }, {
      path: 'adultcontent',
      name: 'terms-adultcontent',
      component: () => import('@/router/page/terms/adultcontent')
    }, {
      path: 'service',
      name: 'terms-service',
      component: () => import('@/router/page/terms/service')
    }, {
      path: 'paidservie',
      name: 'terms-paidservie',
      component: () => import('@/router/page/terms/paidservie')
    }, {
      path: 'personal',
      name: 'terms-personal',
      component: () => import('@/router/page/terms/personal')
    }, {
      path: 'managing',
      name: 'terms-managing',
      component: () => import('@/router/page/terms/managing')
    }, {
      path: 'refund',
      name: 'terms-refund',
      component: () => import('@/router/page/terms/refund')
    }]
  }, {
    path: '/search/:type/:text',
    name: 'search',
    component: () => import('@/router/page/search/search')
  }, {
    path: '/booklist/:type',
    name: 'BooklistInfo',
    component: () => import('@/router/page/library/booklist/BooklistInfo')
  }, {
    path: '/postlist/lately',
    name: 'latelyPostList',
    component: () => import('@/router/page/library/booklist/latelyPostlist')
  }, {
    path: '/postlist/later',
    name: 'laterPostList',
    component: () => import('@/router/page/library/booklist/laterPostlist')
  }, {
    path: '/workinfo/:work',
    name: 'workinfo',
    component: () => import('@/router/page/library/workinfo')
  }, {
    path: '/categoryinfo/:category',
    name: 'categoryinfo',
    component: () => import('@/router/page/library/categoryinfo')
  }, {
    path: '/book/:type/:book',
    name: 'bookinfo',
    component: () => import('@/router/page/library/bookinfo')
  }, {
    path: '/edit/:work/:category/:book/:post',
    name: 'postedit',
    component: () => import('@/router/page/edit.vue')
  }, {
    path: '/edit/:work/:category/:book',
    name: 'bookedit',
    component: () => import('@/router/page/edit.vue')
  }, {
    path: '/edit/:work/:category',
    name: 'categoryedit',
    component: () => import('@/router/page/edit.vue')
  }, {
    path: '/edit/:work',
    name: 'workedit',
    component: () => import('@/router/page/edit.vue')
  }, {
    path: '/edit',
    name: 'edit',
    component: () => import('@/router/page/edit.vue')
  }, {
    path: '/post/:type/:post',
    name: 'post',
    component: () => import('@/router/page/post.vue')
  }, {
    path: '/upenbeedit',
    name: 'upenbeedit',
    component: UpenbeEdit
  }, {
    path: '/auth/:token',
    name: 'auth',
    redirect: (to) => {
      sessionStorage.setItem('token', to.params.token)
      return '/upenbeedit'
    }
  }, {
    path: '/work/:user',
    name: 'directWork',
    beforeEnter: (to, from, next) => {
      axios.post('/api/auth/nicToID', {nic: to.params.user}).then(e => {
        next('/library/worklist/' + e.data)
      })
    }
  }, {
    path: '/secession',
    name: 'secession',
    component: () => import('@/router/page/login/secession.vue')
  }, {
    path: '/popup',
    name: 'popup',
    component: {template: '<router-view></router-view>'},
    children: [{
      path: 'contract/:id',
      name: 'popup-contract',
      component: () => import('@/router/popup/contract.vue')
    }]
  }, {
    path: '/:post',
    name: 'clipboardPost',
    beforeEnter: (to, from, next) => {
      axios.post('/api/library/ispost', {post: to.params.post}).then(e => {
        console.log('ispost', e)
        if (e.ispost) {
          next('/post/info/' + to.params.post)
        } else {
          next('/')
        }
      })
    }
  }, {
    path: '*',
    redirect: (to) => {
      return '/'
    }
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js